import React from 'react'
import styles from './ExecutiveSummary.module.css'

const getTrendMeta = (trend) => {
  const meta = {
    improving: { color: '#22c55e', icon: <span role="img" aria-label="improving trend">📈</span>, label: 'Improving' },
    stable: { color: '#f59e0b', icon: <span role="img" aria-label="stable trend">➡️</span>, label: 'Stable' },
    declining: { color: '#ef4444', icon: <span role="img" aria-label="declining trend">📉</span>, label: 'Declining' }
  }
  return meta[trend] || meta.stable
}

const getScoreBand = (score) => {
  if (score >= 85) return { label: 'Excellent', color: '#52c41a' }
  if (score >= 70) return { label: 'On Track', color: '#1677ff' }
  if (score >= 55) return { label: 'Needs Focus', color: '#faad14' }
  return { label: 'At Risk', color: '#f5222d' }
}

const ExecutiveSummaryHeader = ({ overall }) => {
  const trend = getTrendMeta(overall.trend)
  const band = getScoreBand(overall.current)

  return (
    <div className={styles.headerCard}>
      <div className={styles.headerTop}>
        <div className={styles.headerContent}>
          <h1 className={styles.headerTitle}>Executive Key Insights</h1>
          <p className={styles.headerSubtitle}>{overall.headline}</p>
        </div>
        <div className={styles.scoreSection}>
          <div className={styles.scoreCircle}>
            <div className={styles.scoreInner}>
              <div className={styles.scoreNumber}>{overall.current}</div>
              <div className={styles.scoreText}>HEALTHSPAN</div>
            </div>
          </div>
          <div className={styles.scoreBand}>
            <span className={styles.tag} style={{ backgroundColor: band.color, color: '#fff' }}>
              {band.label}
            </span>
              <span className={styles.trendBadge} style={{ backgroundColor: trend.color, color: '#fff' }}>
                {trend.icon} <span className={styles.trendLabel}>{trend.label}</span>
              </span>
          </div>
        </div>
      </div>
      <div className={styles.headerRow}>
        <div className={styles.headerStatBox}>
          <div className={styles.headerLabel}>Current</div>
          <div className={styles.headerValue}>
            {overall.current}
            <span className={styles.headerValueFraction}>out of {overall.desired}</span>
          </div>
        </div>
        <div className={styles.headerActionsBox}>
          <div className={styles.headerActionsLabel}>Quick Actions</div>
          <ul className={styles.headerActionList}>
            {overall.quick_actions && overall.quick_actions.slice(0, 3).map((action, idx) => (
              <li key={idx} className={styles.headerActionItem}>
                <span role="img" aria-label="action bullet" className={styles.headerActionBullet}>▶</span>
                {action}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default ExecutiveSummaryHeader
